export default __webpack_public_path__ + "static/play-badge-1-a834ddead698c6700ce47da4d476f32b.png";